import React, { useEffect, useState } from 'react';
import AppRoutes from "./main/index";
import { useLocation } from 'react-router-dom';
import Popup from "./pages/GetInvolved/Popup";
import EventPopup from './pages/GetInvolved/EventPopUp';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


function App() {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const hasShownPopup = sessionStorage.getItem('hasShownPopup');

    if (!hasShownPopup) {
      const timer = setTimeout(() => {
        if (location.pathname !== '/event-registration' && location.pathname !== '/events') {
          sessionStorage.setItem('hasShownPopup', true);
          setShowPopup(true);
        }
      }, 3000);
  
      return () => clearTimeout(timer);
    }
    
  }, [location]);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  return (
    <>
      <AppRoutes />
      <Popup show={showPopup} onClose={handleClosePopup} />
      {/* <EventPopup show={showPopup} onClose={handleClosePopup}/> */}
    </>
  );
}

export default App;
